type ErrorContext = Record<string, unknown>;

const stored = (key: string) => typeof window === "undefined" ? "" : localStorage.getItem(key) || "";

let reporting = false;

export async function reportSystemError(error: unknown, context: ErrorContext = {}) {
  if (reporting || typeof window === "undefined") return;
  reporting = true;
  try {
    const value = error instanceof Error ? error : new Error(String(error));
    await fetch("/api/monitor.php", {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: value.message.slice(0, 2000),
        stack: value.stack?.slice(0, 8000),
        url: window.location.href,
        user_agent: navigator.userAgent,
        cliente_id: stored("odonto.activeClienteId"),
        clinica_id: stored("odonto.activeClinicaId"),
        context,
      }),
    });
  } catch {
    // Monitoring must never interrupt the user's workflow.
  } finally {
    reporting = false;
  }
}

export function installGlobalErrorMonitoring() {
  window.addEventListener("error", (event) => {
    void reportSystemError(event.error || event.message, { source: "window.error" });
  });
  window.addEventListener("unhandledrejection", (event) => {
    void reportSystemError(event.reason, { source: "unhandledrejection" });
  });
}
